import { render, staticRenderFns } from "./widget_portfolio_index.vue?vue&type=template&id=b30f0d74&scoped=true&"
import script from "./widget_portfolio_index.vue?vue&type=script&lang=js&"
export * from "./widget_portfolio_index.vue?vue&type=script&lang=js&"
import style0 from "./widget_portfolio_index.vue?vue&type=style&index=0&id=b30f0d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30f0d74",
  null
  
)

export default component.exports